<aux-export-excel-button
  #exportButton
  class="hidden"
  [className]="'ml-1 h-8 bg-white'"
  [gridAPI]="gridAPI()"
  [getDynamicExcelParamsCallback]="getDynamicExcelParams"
  pendoTag="audit-history-excel-export-button"
/>

<aux-button-group
  label="Export"
  [options]="exportOptions"
  [loading]="exportProcessing()"
  [position]="menuPosition"
/>
